// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #0f172a;
  background-image: 
    radial-gradient(at 0% 0%, rgba(99, 102, 241, 0.15) 0px, transparent 50%),
    radial-gradient(at 50% 0%, rgba(168, 85, 247, 0.15) 0px, transparent 50%),
    radial-gradient(at 100% 100%, rgba(59, 130, 246, 0.15) 0px, transparent 50%);
  padding: 20px;
  position: relative;
  overflow: hidden;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
}

.register-container::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background-image: 
    radial-gradient(circle at 20% 50%, rgba(99, 102, 241, 0.08) 1px, transparent 1px),
    radial-gradient(circle at 80% 20%, rgba(168, 85, 247, 0.08) 1px, transparent 1px),
    radial-gradient(circle at 40% 80%, rgba(59, 130, 246, 0.08) 1px, transparent 1px);
  background-size: 80px 80px, 120px 120px, 100px 100px;
  animation: float 20s ease-in-out infinite;
  pointer-events: none;
}

@keyframes float {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  25% { transform: translate(2%, 1%) rotate(1deg); }
  50% { transform: translate(-1%, 2%) rotate(-1deg); }
  75% { transform: translate(1%, -1%) rotate(0.5deg); }
}

.register-card {
  position: relative;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(40px) saturate(180%);
  -webkit-backdrop-filter: blur(40px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 
    0 25px 50px -12px rgba(0, 0, 0, 0.5),
    0 0 0 1px rgba(255, 255, 255, 0.05) inset,
    0 0 80px rgba(99, 102, 241, 0.15);
  border-radius: 24px;
  padding: 48px;
  width: 100%;
  max-width: 440px;
  animation: slideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.register-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  border-radius: 24px 24px 0 0;
}

.register-header {
  text-align: center;
  margin-bottom: 36px;
}

.register-header h1 {
  margin: 0 0 10px;
  color: #f8fafc;
  font-size: 30px;
  font-weight: 700;
  letter-spacing: -0.02em;
  background: linear-gradient(135deg, #fff 0%, rgba(255, 255, 255, 0.8) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.register-header p {
  color: rgba(148, 163, 184, 0.9);
  margin: 0;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 0.01em;
}

.form-group {
  margin-bottom: 22px;
  position: relative;
}

.form-group label {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
  color: #e2e8f0;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.01em;
  transition: color 0.2s ease;
}

.form-group input {
  width: 100%;
  padding: 14px 16px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 14px;
  font-size: 15px;
  color: #f1f5f9;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  box-sizing: border-box;
  backdrop-filter: blur(10px);
  font-family: inherit;
  letter-spacing: 0.01em;
}

.form-group input::placeholder {
  color: rgba(148, 163, 184, 0.6);
}

.form-group input:focus {
  outline: none;
  border-color: rgba(99, 102, 241, 0.6);
  background: rgba(255, 255, 255, 0.08);
  box-shadow: 
    0 0 0 4px rgba(99, 102, 241, 0.15),
    0 4px 20px rgba(99, 102, 241, 0.2);
  transform: translateY(-1px);
}

.form-group input:hover:not(:focus) {
  border-color: rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.06);
}

.error-message {
  background: rgba(239, 68, 68, 0.08);
  border: 1px solid rgba(239, 68, 68, 0.2);
  color: #fca5a5;
  padding: 14px 16px;
  border-radius: 12px;
  margin-bottom: 24px;
  font-size: 14px;
  backdrop-filter: blur(10px);
  animation: shake 0.4s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-6px); }
  75% { transform: translateX(6px); }
}

.btn-primary {
  width: 100%;
  padding: 16px;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: white;
  border: none;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  margin-top: 8px;
  font-family: inherit;
  letter-spacing: 0.02em;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(99, 102, 241, 0.4);
}

.btn-primary::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255,255,255,0.15) 0%, transparent 50%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(99, 102, 241, 0.5);
}

.btn-primary:hover:not(:disabled)::before {
  opacity: 1;
}

.btn-primary:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 2px 10px rgba(99, 102, 241, 0.4);
}

.btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.register-footer {
  text-align: center;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.register-footer p {
  margin: 0;
  color: #94a3b8;
  font-size: 14px;
}

.register-footer a {
  color: #818cf8;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.2s ease;
  position: relative;
}

.register-footer a::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #6366f1, #8b5cf6);
  transition: width 0.3s ease;
  border-radius: 2px;
}

.register-footer a:hover {
  color: #a5b4fc;
}

.register-footer a:hover::after {
  width: 100%;
}

.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input-wrapper input {
  padding-right: 48px;
}

.password-input-wrapper .password-toggle {
  position: absolute;
  right: 14px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  cursor: pointer;
  font-size: 18px;
  padding: 6px;
  color: #94a3b8;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  transition: all 0.2s ease;
  backdrop-filter: blur(10px);
}

.password-input-wrapper .password-toggle:hover {
  color: #e2e8f0;
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
  transform: scale(1.05);
}

.password-input-wrapper .password-toggle svg {
  width: 16px;
  height: 16px;
}

/* Responsive */
@media (max-width: 480px) {
  .register-card {
    padding: 32px 24px;
    margin: 16px;
    border-radius: 20px;
    max-width: 100%;
  }

  .register-header h1 {
    font-size: 26px;
  }

  .form-group input {
    padding: 12px 14px;
    font-size: 16px;
  }

  .btn-primary {
    padding: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Register.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB;;;gFAG8E;EAC9E,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,uGAAuG;AACzG;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ;;;qFAGmF;EACnF,oDAAoD;EACpD,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,WAAW,uCAAuC,EAAE;EACpD,MAAM,yCAAyC,EAAE;EACjD,MAAM,2CAA2C,EAAE;EACnD,MAAM,4CAA4C,EAAE;AACtD;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,kDAAkD;EAClD,0CAA0C;EAC1C;;;qCAGmC;EACnC,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,sFAAsF;EACtF,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,2EAA2E;EAC3E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,kDAAkD;EAClD,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,qCAAqC;EACrC;;sCAEoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;AACpC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kDAAkD;EAClD,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+EAA+E;EAC/E,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;EACpD,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qCAAqC;EACrC,2CAA2C;EAC3C,eAAe;EACf,eAAe;EACf,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,eAAe;AACf;EACE;IACE,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');\n\n.register-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: #0f172a;\n  background-image: \n    radial-gradient(at 0% 0%, rgba(99, 102, 241, 0.15) 0px, transparent 50%),\n    radial-gradient(at 50% 0%, rgba(168, 85, 247, 0.15) 0px, transparent 50%),\n    radial-gradient(at 100% 100%, rgba(59, 130, 246, 0.15) 0px, transparent 50%);\n  padding: 20px;\n  position: relative;\n  overflow: hidden;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;\n}\n\n.register-container::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  width: 200%;\n  height: 200%;\n  background-image: \n    radial-gradient(circle at 20% 50%, rgba(99, 102, 241, 0.08) 1px, transparent 1px),\n    radial-gradient(circle at 80% 20%, rgba(168, 85, 247, 0.08) 1px, transparent 1px),\n    radial-gradient(circle at 40% 80%, rgba(59, 130, 246, 0.08) 1px, transparent 1px);\n  background-size: 80px 80px, 120px 120px, 100px 100px;\n  animation: float 20s ease-in-out infinite;\n  pointer-events: none;\n}\n\n@keyframes float {\n  0%, 100% { transform: translate(0, 0) rotate(0deg); }\n  25% { transform: translate(2%, 1%) rotate(1deg); }\n  50% { transform: translate(-1%, 2%) rotate(-1deg); }\n  75% { transform: translate(1%, -1%) rotate(0.5deg); }\n}\n\n.register-card {\n  position: relative;\n  background: rgba(255, 255, 255, 0.03);\n  backdrop-filter: blur(40px) saturate(180%);\n  -webkit-backdrop-filter: blur(40px) saturate(180%);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: \n    0 25px 50px -12px rgba(0, 0, 0, 0.5),\n    0 0 0 1px rgba(255, 255, 255, 0.05) inset,\n    0 0 80px rgba(99, 102, 241, 0.15);\n  border-radius: 24px;\n  padding: 48px;\n  width: 100%;\n  max-width: 440px;\n  animation: slideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px) scale(0.96);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.register-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  border-radius: 24px 24px 0 0;\n}\n\n.register-header {\n  text-align: center;\n  margin-bottom: 36px;\n}\n\n.register-header h1 {\n  margin: 0 0 10px;\n  color: #f8fafc;\n  font-size: 30px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  background: linear-gradient(135deg, #fff 0%, rgba(255, 255, 255, 0.8) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.register-header p {\n  color: rgba(148, 163, 184, 0.9);\n  margin: 0;\n  font-size: 15px;\n  font-weight: 400;\n  letter-spacing: 0.01em;\n}\n\n.form-group {\n  margin-bottom: 22px;\n  position: relative;\n}\n\n.form-group label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 8px;\n  color: #e2e8f0;\n  font-weight: 500;\n  font-size: 14px;\n  letter-spacing: 0.01em;\n  transition: color 0.2s ease;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 14px 16px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 14px;\n  font-size: 15px;\n  color: #f1f5f9;\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n  box-sizing: border-box;\n  backdrop-filter: blur(10px);\n  font-family: inherit;\n  letter-spacing: 0.01em;\n}\n\n.form-group input::placeholder {\n  color: rgba(148, 163, 184, 0.6);\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: rgba(99, 102, 241, 0.6);\n  background: rgba(255, 255, 255, 0.08);\n  box-shadow: \n    0 0 0 4px rgba(99, 102, 241, 0.15),\n    0 4px 20px rgba(99, 102, 241, 0.2);\n  transform: translateY(-1px);\n}\n\n.form-group input:hover:not(:focus) {\n  border-color: rgba(255, 255, 255, 0.2);\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.error-message {\n  background: rgba(239, 68, 68, 0.08);\n  border: 1px solid rgba(239, 68, 68, 0.2);\n  color: #fca5a5;\n  padding: 14px 16px;\n  border-radius: 12px;\n  margin-bottom: 24px;\n  font-size: 14px;\n  backdrop-filter: blur(10px);\n  animation: shake 0.4s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n@keyframes shake {\n  0%, 100% { transform: translateX(0); }\n  25% { transform: translateX(-6px); }\n  75% { transform: translateX(6px); }\n}\n\n.btn-primary {\n  width: 100%;\n  padding: 16px;\n  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);\n  color: white;\n  border: none;\n  border-radius: 14px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n  margin-top: 8px;\n  font-family: inherit;\n  letter-spacing: 0.02em;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 4px 15px rgba(99, 102, 241, 0.4);\n}\n\n.btn-primary::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, rgba(255,255,255,0.15) 0%, transparent 50%);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.btn-primary:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(99, 102, 241, 0.5);\n}\n\n.btn-primary:hover:not(:disabled)::before {\n  opacity: 1;\n}\n\n.btn-primary:active:not(:disabled) {\n  transform: translateY(0);\n  box-shadow: 0 2px 10px rgba(99, 102, 241, 0.4);\n}\n\n.btn-primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.register-footer {\n  text-align: center;\n  margin-top: 32px;\n  padding-top: 24px;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.register-footer p {\n  margin: 0;\n  color: #94a3b8;\n  font-size: 14px;\n}\n\n.register-footer a {\n  color: #818cf8;\n  text-decoration: none;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n.register-footer a::after {\n  content: '';\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  width: 0;\n  height: 2px;\n  background: linear-gradient(90deg, #6366f1, #8b5cf6);\n  transition: width 0.3s ease;\n  border-radius: 2px;\n}\n\n.register-footer a:hover {\n  color: #a5b4fc;\n}\n\n.register-footer a:hover::after {\n  width: 100%;\n}\n\n.password-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.password-input-wrapper input {\n  padding-right: 48px;\n}\n\n.password-input-wrapper .password-toggle {\n  position: absolute;\n  right: 14px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  cursor: pointer;\n  font-size: 18px;\n  padding: 6px;\n  color: #94a3b8;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  backdrop-filter: blur(10px);\n}\n\n.password-input-wrapper .password-toggle:hover {\n  color: #e2e8f0;\n  background: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255, 255, 255, 0.2);\n  transform: scale(1.05);\n}\n\n.password-input-wrapper .password-toggle svg {\n  width: 16px;\n  height: 16px;\n}\n\n/* Responsive */\n@media (max-width: 480px) {\n  .register-card {\n    padding: 32px 24px;\n    margin: 16px;\n    border-radius: 20px;\n    max-width: 100%;\n  }\n\n  .register-header h1 {\n    font-size: 26px;\n  }\n\n  .form-group input {\n    padding: 12px 14px;\n    font-size: 16px;\n  }\n\n  .btn-primary {\n    padding: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
